import { contactData } from '@/mocks/homepage';
import { useState } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }
    formData.delete('phone_alt');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9k6v78h9dsfbuoi6b00', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch (_) { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试');
      }
    } catch (_) {
      setFormStatus('error');
      setFormError('网络错误，请检查网络后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            {contactData.subtitle}
          </p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 space-y-5">
            <div className="flex items-center gap-4 bg-background-50 rounded-xl p-4">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center text-accent-600 flex-shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-4 bg-background-50 rounded-xl p-4">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center text-secondary-600 flex-shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">微信公众号</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
              </div>
            </div>
            <div className="flex items-center gap-4 bg-background-50 rounded-xl p-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center text-primary-500 flex-shrink-0">
                <i className="ri-weibo-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">官方微博</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.weibo}</div>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <form
              data-readdy-form="true"
              className="bg-background-50 rounded-xl p-5 md:p-6 space-y-4"
              onSubmit={handleSubmit}
            >
              {formStatus === 'success' && (
                <div className="bg-accent-100 text-accent-800 text-sm rounded-lg p-3">
                  感谢您的留言，我们会尽快回复！
                </div>
              )}
              {formStatus === 'error' && (
                <div className="bg-secondary-100 text-secondary-800 text-sm rounded-lg p-3">
                  {formError}
                </div>
              )}
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                  您的称呼
                </label>
                <input
                  type="text"
                  name="name"
                  className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的称呼"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                  电子邮箱
                </label>
                <input
                  type="email"
                  name="email"
                  className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                  留言内容
                </label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-300/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言（500字以内）"
                ></textarea>
              </div>
              <div className="anti-spam-field">
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <button
                type="submit"
                className="w-full py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                发送留言
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}